import {setLoading, setConfig, setMaintenance, setBookingList, setCurrentState, setConnectionStatus, clearConnectionLogs} from "../../../reducers/configSlice";
import {CONFIG_STATUS_PENDING, SOCKET_CONNECTED, STATE_HOME, STATE_WAITING} from "../../../constants/default";
import moment from "moment";
import moment_tz from "moment-timezone";
import {getState} from "../../state/getState";
import {dispatchAction} from "../../state/dispatchAction";
import {deviceLeds} from "../../deviceLeds";
import {emitFutureBookingList, emitMaintenanceStatus} from "../socket";
import {hideToast, showToastMessage} from "../../toastMessage";
import {STORAGE} from "../../storage";
import {storeDeviceUuid} from "../../helpers/getDeviceUuid";
import {triggerMigrationToSoketi} from "../../migration/migrationService";

export const handleConfig = (socket) => async (msg) => {
    hideToast();

    if (msg.status === CONFIG_STATUS_PENDING) {
        dispatchAction(setLoading(false));
        dispatchAction(setCurrentState(STATE_WAITING));
        return;
    }

    // Check for Soketi URL in config message - trigger migration if present
    if (msg.soketiUrl) {
        // Trigger seamless migration to Soketi
        const migrationSuccess = await triggerMigrationToSoketi(socket, msg.soketiUrl, msg);

        if (migrationSuccess) {
            return; // Stop Socket.IO processing, Soketi will handle the config
        }
    }

    const config = {...msg.config};

    // Store device UUID if present in config message (for token refresh)
    if (msg.uuid) {
        await storeDeviceUuid(msg.uuid);
    }

    if (config?.light_driver?.prodvx_token) {
        await STORAGE.set('prodvx_token', config.light_driver.prodvx_token);
    }

    const prodvxtoken = await STORAGE.get('prodvx_token');

    dispatchAction(setConfig(config));
    deviceLeds('off', config?.light_driver, prodvxtoken);

    emitFutureBookingList()
    emitMaintenanceStatus()
    setupDynamicListeners(socket, msg.uuid, config);

    if (getState('authenticated')) {
        dispatchAction(setLoading(false));
        dispatchAction(setCurrentState(STATE_HOME));
    }

    dispatchAction(setConnectionStatus(SOCKET_CONNECTED));
    dispatchAction(clearConnectionLogs());
};

const setupDynamicListeners = (socket, uuid, config) => {
    const bookingListEvent = `booking_list_${uuid}`;
    const maintenanceEvent = `maintenance_${uuid}`;

    socket.off(bookingListEvent);
    socket.off(maintenanceEvent);

    socket.on(bookingListEvent, (msg) => {
        dispatchAction(setLoading(false))
        dispatchAction(setBookingList(msg));
    });

    socket.on(maintenanceEvent, (msg) => {
        if (msg &&
            moment().tz(config.timezone).isSameOrAfter(moment_tz.tz(msg.start, config.timezone).utc().tz(config.timezone)) &&
            moment().tz(config.timezone).isBefore(moment_tz.tz(msg.end, config.timezone).utc().tz(config.timezone))
        ) {
            dispatchAction(setMaintenance(msg))
        } else {
            dispatchAction(setMaintenance(null))
        }
    });
};
